<template>
  <v-dialog v-model="active" max-width="350">
    <v-card class="text-center">
      <v-card-title class="text-h6 red--text">
        <p class="fw">
          <v-icon color="red" class="mr-1"> mdi-alert </v-icon> Unsaved Changes
          Detected
        </p>
      </v-card-title>

      <v-card-text>
        <h4>{{ msg }}</h4>
      </v-card-text>

      <v-card-actions>
        <v-btn color="success darken-1" text @click="active = false">
          Go Back!
        </v-btn>
        <v-spacer> </v-spacer>
        <v-btn color="error" @click="routeOut">
          <v-icon dark class="mr-1"> mdi-content-save-off </v-icon> Discard
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import Vue from "vue";
import VueTypes from "vue-types";

export default Vue.extend({
  name: "ExitModal",

  data() {
    return {};
  },
  props: {
    msg: VueTypes.string.def("Discard Changes?"),
  },
  computed: {
    active: {
      get(): boolean {
        return this.$store.getters.getExitDialog;
      },
      set(val: boolean) {
        this.$store.commit("setExitDialog", val);
      },
    },
    to: {
      get(): string {
        return this.$store.getters.getExitDialogTo;
      },
      set(val: string) {
        this.$store.commit("setExitDialogTo", val);
      },
    },
  },
  methods: {
    routeOut() {
      this.$router.push(this.to);
      this.active = false;
    },
  },
});
</script>
<style scoped></style>
